/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { defaultGeomatique } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_pres_009: Question = {
  id: 'pres-009-nombre-parcelles-terrestres',
  oldId: '23',
  title: 'Nombre de parcelles des milieux naturels terrestres',
  number: '2.9',
  description: [''],
  type: QuestionType.INDICATOR,
  frequency: 4,
  slots: [
    {
      type: SlotTypes.GEOMATIQUE,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: true,
      optional: false,
      scoringFct: (data: string[]) => data,
      score: '0',
      help: defaultGeomatique,
      unit: SlotUnit.NUMBER_OF,
    },
  ],
};
const question_pres_009__v3: Question = {
  ...question_pres_009,
  number: '2.8',
};

export const question_pres_009_v2: Question = question_pres_009;
export const question_pres_009_v3: Question = question_pres_009__v3;
